var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgId({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 39H39C40.1935 39 41.3381 38.5259 42.182 37.682C43.0259 36.8381 43.5 35.6935 43.5 34.5V13.5C43.5 12.3065 43.0259 11.1619 42.182 10.318C41.3381 9.47411 40.1935 9 39 9H9C7.80653 9 6.66193 9.47411 5.81802 10.318C4.97411 11.1619 4.5 12.3065 4.5 13.5V34.5C4.5 35.6935 4.97411 36.8381 5.81802 37.682C6.66193 38.5259 7.80653 39 9 39ZM21 18.75C21 19.2425 20.903 19.7301 20.7145 20.1851C20.5261 20.64 20.2499 21.0534 19.9017 21.4017C19.5534 21.7499 19.14 22.0261 18.6851 22.2145C18.2301 22.403 17.7425 22.5 17.25 22.5C16.7575 22.5 16.2699 22.403 15.8149 22.2145C15.36 22.0261 14.9466 21.7499 14.5983 21.4017C14.2501 21.0534 13.9739 20.64 13.7855 20.1851C13.597 19.7301 13.5 19.2425 13.5 18.75C13.5 17.7554 13.8951 16.8016 14.5983 16.0984C15.3016 15.3951 16.2554 15 17.25 15C18.2446 15 19.1984 15.3951 19.9016 16.0984C20.6049 16.8016 21 17.7554 21 18.75ZM23.588 31.422C21.6366 32.4614 19.4589 33.0034 17.248 33C15.0384 33.0028 12.8622 32.4608 10.912 31.422C11.3886 30.1245 12.2519 29.0045 13.3853 28.2133C14.5188 27.4222 15.8677 26.9979 17.25 26.9979C18.6323 26.9979 19.9812 27.4222 21.1147 28.2133C22.2481 29.0045 23.1114 30.1245 23.588 31.422Z",
    stroke: "#00B3B5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18H37.5M30 24H37.5M30 30H37.5",
    stroke: "#FEC10D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 18H37.5M30 24H37.5M30 30H37.5",
    stroke: "black",
    strokeOpacity: 0.15,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgId);
export default __webpack_public_path__ + "static/media/id.7ec0402ab20261ba0dd9be3090e4138c.svg";
export { ForwardRef as ReactComponent };